// TOP キービジュアル: 4枚スライドの自動切替（クロスフェード）+ 右→左 linear パン（WAAPI）。
// マークアップ: .g26-c-hero / .g26-c-hero__slide(.is-active) / .g26-c-hero__dot

const INTERVAL = 6000; // 表示時間
const PAN_MS = 8200; // パン尺（表示 + フェード分やや長め）
// 中央トリミング基準のパン（ISSUE行5）: 画像は CSS で左右均等にはみ出させ（中央クロップ）、
// 中央±半振幅で右→左へ流す。トリミングが常に中央付近に保たれる。
const PAN_HALF_PC = "3%"; // PC: 総移動量6%（画像幅に対して）
const PAN_HALF_SP = "5%"; // SP: 画面が狭くパンが目立たないため移動量を増やす（CSS で画像を 120% に広げ余地を確保）
const SP_MQ = "(max-width: 840px)"; // CSS の --sp と一致

function initHero(root: HTMLElement): void {
  const slides = Array.from(
    root.querySelectorAll<HTMLElement>(".g26-c-hero__slide")
  );
  const dots = Array.from(
    root.querySelectorAll<HTMLElement>(".g26-c-hero__dot")
  );
  if (slides.length < 2) return;

  let current = 0;
  let timer = 0;

  const pan = (slide: HTMLElement): void => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const img = slide.querySelector<HTMLElement>(".g26-c-hero__img");
    if (img && typeof img.animate === "function") {
      const half = window.matchMedia(SP_MQ).matches ? PAN_HALF_SP : PAN_HALF_PC;
      img.animate(
        [{ transform: `translateX(${half})` }, { transform: `translateX(-${half})` }],
        { duration: PAN_MS, easing: "linear", fill: "forwards" }
      );
    }
  };

  const show = (next: number): void => {
    const n = (next + slides.length) % slides.length;
    if (n === current) return;
    slides[current].classList.remove("is-active");
    dots[current]?.classList.remove("is-active");
    current = n;
    slides[current].classList.add("is-active");
    dots[current]?.classList.add("is-active");
    pan(slides[current]);
  };

  const start = (): void => {
    stop();
    timer = window.setInterval(() => show(current + 1), INTERVAL);
  };
  const stop = (): void => {
    if (timer) window.clearInterval(timer);
  };

  dots.forEach((dot, n) =>
    dot.addEventListener("click", () => {
      show(n);
      start(); // 手動操作で自動再生をリセット
    })
  );

  // 初期スライドのパン開始
  pan(slides[current]);
  start();
}

document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll<HTMLElement>(".g26-c-hero")
    .forEach((el) => initHero(el));
});

export {};
